import React from 'react'
import { formatDate } from '../../utils/dateUtils'
import StarRating from '../StarRating'

const PoiComment = ({ comment }) => (
  <div className="comment-card">
    <div className="comment-body">
      {comment.comment && <p>{comment.comment}</p>}
      {comment.rating && <StarRating rating={comment.rating} />}
    </div>
    <div className="comment-footer">
      <small className="text-muted">
        {formatDate(comment.createdAt, true)} — {comment.createdBy.firstname}{' '}
        {comment.createdBy.lastname}
      </small>
    </div>
  </div>
)

export default PoiComment
